export default {
  basics: {
    icon: 'mdi-information-outline',
    color: 'primary',
    title: 'Basics',
    text: 'Basics',
    tooltip: 'Basics'
  },
  details: {
    icon: 'mdi-information-outline',
    color: 'purple',
    title: 'Details',
    text: 'Details',
    tooltip: 'Details'
  },
  hold: {
    icon: 'mdi-hand-front-left',
    color: 'error',
  },
  remove_hold: {
    icon: 'mdi-hand-back-left-off',
    color: 'success',
  },
  crewVisits: {
    title: 'Crew Visits',
    icon: 'mdi-car-pickup',
    color: 'blue-grey'
  },
  pdf: {
    title: 'PDF',
    icon: 'mdi-file-pdf-box',
    color: 'grey darken-2'
  },
  tasks: {
    title: 'Tasks',
    icon: 'mdi-clipboard-list',
    color: 'brown'
  },
  task_new: {
    title: 'New Task',
    icon: 'mdi-clipboard-edit-outline',
    color: 'primary',
    tooltip: ''
  },
  task_unread: {
    title: 'New Task',
    icon: 'mdi-clipboard-alert-outline',
    color: 'error',
    tooltip: 'new task (not opened/read yet)'
  },
  task_read: {
    title: 'Pending',
    icon: 'mdi-clipboard-outline',
    color: 'info',
    tooltip: 'task pending (assignee has opened it)'
  },
  task_progress: {
    title: 'In Progress',
    icon: 'mdi-clipboard-arrow-right-outline',
    color: 'primary',
    tooltip: 'task marked as in-progress'
  },
  task_attempted: {
    title: 'Attempted',
    icon: 'mdi-clipboard-text-outline',
    color: 'warning',
    tooltip: 'task marked as attempted'
  },
  task_complete: {
    title: 'Complete',
    icon: 'mdi-clipboard-check-outline',
    color: 'success',
    tooltip: 'task marked as complete'
  },
  mail_new: {
    title: 'New Mail',
    icon: 'mdi-email',
    color: 'info'
  },
  mail_read: {
    title: 'Mail',
    icon: 'mdi-email-open-outline',
    color: 'info'
  }
}